// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _ from 'lodash';
import { axios } from './axios';
import { toast } from "sonner";
import { showSuccess, showError } from '../actions/globalActions';

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const useSummaryStore = create(immer((set) => ({
  summary: {},
  recent: {},
  upcoming: {},
  monthlyRevenue: {},
  teamsRegistered: {},
  cloudflareAnalytics: {},
  setup: {},
  getSummary: (getToken) => {
    return async (leagueId) => {
      try {
        const token = await getToken();
        const { data } = await axios.get(`${baseUrl}/summary/dashboard/${leagueId}`, createAuthHeader(token));
        set((state) => {
          state.summary = data.result;
        });
      } catch (error) {
        showError("Error", "Get Summary Error");
        console.error("Error in getSummary:", error);
      }
    };
  },

  getRecent: (getToken) => {
    return async (leagueId) => {
      try {
        const token = await getToken();
        const { data } = await axios.get(`${baseUrl}/summary/recent/${leagueId}`, createAuthHeader(token));
        set((state) => {
          state.recent = data.result;
        });
      } catch (error) {
        showError("Error", "Get Recent Error");
        console.error("Error in getRecent:", error);
      }
    };
  },

  getUpcoming: (getToken) => {
    return async (leagueId) => {
      try {
        const token = await getToken();
        const { data } = await axios.get(`${baseUrl}/summary/upcoming/${leagueId}`, createAuthHeader(token));
        set((state) => {
        state.upcoming = data.result;
        });
      } catch (error) {
        showError("Error", "Get Upcoming Error");
        console.error("Error in getUpcoming:", error);
      }
    };
  },

  getMonthlyRevenue: (getToken) => {
    return async (leagueId) => {
      try {
        const token = await getToken();
        const { data } = await axios.get(`${baseUrl}/summary/monthlyRevenue/${leagueId}`, createAuthHeader(token));
        set((state) => {
          state.monthlyRevenue = data.result;
        });
      } catch (error) {
        showError("Error", "Get Monthly Revenue Error");
        console.error("Error in getMonthlyRevenue:", error);
      }
    };
  },

  getTeamsRegistered: (getToken) => {
    return async (leagueId) => {
      try {
        const token = await getToken();
        const { data } = await axios.get(`${baseUrl}/summary/teamsRegistered/${leagueId}`, createAuthHeader(token));
        set((state) => {
          state.teamsRegistered = data.result;
        });
      } catch (error) {
        showError("Error", "Get Teams Registered Error");
        console.error("Error in getTeamsRegistered:", error);
      }
    };
  },

  getCloudflareAnalytics: (getToken) => {
    return async (leagueId) => {
      try {
        const token = await getToken();
        const { data } = await axios.get(`${baseUrl}/summary/cloudflareAnalytics/${leagueId}`, createAuthHeader(token));
        set((state) => {
          state.cloudflareAnalytics = data.result;
        });
      } catch (error) {
        showError("Error", "Get Cloudflare Analytics Error");
        console.error("Error in getCloudflareAnalytics:", error);
      }
    };
  },

  getSetup: (getToken) => {
    return async (leagueId) => {
      try {
        const token = await getToken();
        const { data } = await axios.get(`${baseUrl}/summary/setup/${leagueId}`, createAuthHeader(token));
        set((state) => {
          state.setup = data.result;
        });
      } catch (error) {
        showError("Error", "Get Setup Error");
        console.error("Error in getSetup:", error);
      }
    };
  },
})));

export default useSummaryStore;